"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var OrsInput = /*#__PURE__*/function () {
  function OrsInput(input, input2) {
    _classCallCheck(this, OrsInput);

    this.setCoord(input, input2);
  }

  _createClass(OrsInput, [{
    key: "round",
    value: function round(val, precision) {
      if (precision === undefined) precision = 1e6;
      return Math.round(val * precision) / precision;
    }
  }, {
    key: "setCoord",
    value: function setCoord(lat, lng) {
      this.coord = [this.round(lat), this.round(lng)];
    }
  }]);

  return OrsInput;
}();

var _default = OrsInput;
exports["default"] = _default;